export function getTemplateDisplayDescription(
  description: string | null | undefined,
): string {
  // Hide generated provenance in presentation without altering editable data.
  if (
    description === "Saved from /simulate" ||
    description === "Created from scheduled evaluation"
  ) {
    return ""
  }
  return description ?? ""
}
